import { Injectable } from '@angular/core';

@Injectable()
export class GUILogicService {

  constructor() { }

  public getStateCellStyleClass(pSpan,pState : any) {
    let styleclass : string = "";
    if(pState != null) {
      if(pState === 10) {
        styleclass = "pl-state-open";
      }
      if(pState === 15) {
        styleclass = "pl-state-released";
      }
      if(pState === 16) {
        styleclass = "pl-state-inprocess";
      }
      if(pState === 20) {
        styleclass = "pl-state-inprocess";
      }
      if(pState === 40) {
        styleclass = "pl-state-stopped";
      }
      if(pState === 60) {
        styleclass = "pl-state-finished";
      }
    }
    if(styleclass !== "")
      pSpan.parentNode.parentNode.classList.add(styleclass);
  }
}



// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/guilogic.service.ts